import PropTypes from 'prop-types';
import React from 'react';

import classNames from 'classnames';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';
import Col from 'ui-library/bs/Col';
import Row from 'ui-library/bs/Row';

export function Checkmark({isGreen}) {
  return (
    <BenchlingIcon
      icon="check"
      className={classNames('u-input-line-height checkmarkBullet-icon', {
        'checkmarkBullet-icon--green': isGreen,
        'checkmarkBullet-icon--blue': !isGreen,
      })}
    />
  );
}

Checkmark.propTypes = {
  isGreen: PropTypes.bool.isRequired,
};

export default function CheckmarkBullet({className, isGreen, text}) {
  return (
    <Row className={classNames('checkmarkBullet', className)}>
      <Col xs={1}>
        <Checkmark isGreen={isGreen} />
      </Col>
      <Col xs={10} className="checkmarkBullet-text">
        {text}
      </Col>
    </Row>
  );
}

CheckmarkBullet.propTypes = {
  className: PropTypes.string,
  isGreen: PropTypes.bool.isRequired,
  text: PropTypes.string.isRequired,
};
